module.exports = __webpack_public_path__ + "img/Flag_of_Indonesia.9d8ebfcc.svg";